// src/pages/TermsOfUse.jsx
import LegalLayout from "../components/LegalLayout";

export default function TermsOfUse() {
  return (
    <LegalLayout
      title="Kullanım Koşulları ve Platform Sözleşmesi"
      updatedAt="18.12.2025"
      subtitle="KolayYük, yük verenler ile taşıyıcıları buluşturan bir dijital platform/MVP’dir. KolayYük taşıma hizmeti sunmaz, ödeme/komisyon almaz ve taraflar arasında kurulan anlaşmaların tarafı değildir."
    >
      {/* 1 */}
      <Section title="1. Taraflar">
        <p className={styles.p}>
          İşbu Kullanım Koşulları ve Platform Sözleşmesi (“Sözleşme”); bir tarafta
          KolayYük mobil uygulamasının geliştiricisi olan{" "}
          <strong>Süleyman Kaan Büyükkatırcı</strong> (“Platform Sahibi”) ile, diğer
          tarafta KolayYük uygulamasına üye olan gerçek veya tüzel kişi kullanıcı
          (“Kullanıcı”) arasında elektronik ortamda akdedilmiştir.
        </p>
        <p className={styles.p}>
          Platform Sahibi ve Kullanıcı birlikte “Taraflar” olarak anılacaktır.
        </p>
      </Section>

      {/* 2 */}
      <Section title="2. Sözleşmenin Konusu">
        <p className={styles.p}>
          İşbu Sözleşme’nin konusu; KolayYük mobil uygulamasını kullanan yük
          sahipleri (“Yük Veren”) ile taşıma faaliyeti gerçekleştiren kişiler
          (“Taşıyıcı”) arasındaki bilgi paylaşımı ve eşleştirme sürecine ilişkin
          olarak Platform’un kullanım şartlarını ve Tarafların hak ve
          yükümlülüklerini düzenlemektir.
        </p>
        <p className={styles.p}>
          KolayYük, taşıma hizmeti sunan, organize eden veya taahhüt eden bir kuruluş
          değildir. Platform yalnızca tarafların birbirlerini bulmalarını sağlayan
          dijital bir arayüz işlevi görür.
        </p>
      </Section>

      {/* 3 */}
      <Section title="3. Taşıyıcı Kullanıcıların Hak ve Yükümlülükleri">
        <p className={styles.p}>
          Taşıyıcı Kullanıcı, yükün taşınması sırasında meydana gelebilecek her türlü
          zarar, kayıp, gecikme, kaza, hukuka aykırı fiil ve mevzuata aykırılıklardan
          münhasıran kendisinin sorumlu olduğunu kabul eder.
        </p>
        <p className={styles.p}>
          Platform Sahibi, taşıma faaliyetinin niteliği, güvenliği, sigortalanması veya
          hukuka uygunluğu konusunda herhangi bir garanti vermez.
        </p>
      </Section>

      {/* 4 */}
      <Section title="4. Yük Veren Kullanıcıların Hak ve Yükümlülükleri">
        <p className={styles.p}>
          Yük Veren Kullanıcı, Platform üzerinden iletişim kurduğu Taşıyıcılar ile yaptığı
          anlaşmalardan ve bu anlaşmaların sonuçlarından bizzat sorumludur.
        </p>
        <p className={styles.p}>
          Yük Veren Kullanıcı, yükün niteliği, içeriği ve taşımaya uygunluğu konusunda doğru
          bilgi vermekle yükümlüdür.
        </p>
      </Section>

      {/* 5 */}
      <Section title="5. Platform Sahibinin Rolü ve Sorumluluğu">
        <ul className={styles.ul}>
          <li className={styles.li}>Taşıma hizmeti sunmaz</li>
          <li className={styles.li}>Ödeme almaz veya yönlendirme yapmaz</li>
          <li className={styles.li}>Taşıma sözleşmesi oluşturmaz</li>
          <li className={styles.li}>Taşıma sürecine müdahil olmaz</li>
        </ul>
        <p className={styles.p}>
          Platform Sahibi yalnızca Platform’un teknik olarak çalışmasını sağlamakla yükümlüdür
          ve makul çaba göstermeyi taahhüt eder.
        </p>
      </Section>

      {/* 6 */}
      <Section title="6. Platformun Ücretsiz Niteliği">
        <p className={styles.p}>
          KolayYük, MVP (Minimum Viable Product) niteliğinde olup tamamen ücretsizdir.
          Platform üzerinden herhangi bir ücret, komisyon veya bedel talep edilmez.
        </p>
        <p className={styles.p}>
          Gelecekte ücretli hizmetlere geçilmesi halinde Kullanıcılar ayrıca bilgilendirilecektir.
        </p>
      </Section>

      {/* 7 */}
      <Section title="7. Veri Güvenliği ve Gizlilik">
        <p className={styles.p}>
          Platform Sahibi, kullanıcı verilerinin korunması konusunda yürürlükte bulunan mevzuata
          uygun hareket eder. Kişisel verilerin işlenmesine ilişkin esaslar Gizlilik Politikası ve
          KVKK Aydınlatma Metni kapsamında düzenlenmiştir.
        </p>
      </Section>

      {/* 8 */}
      <Section title="8. Sorumluluk Reddi">
        <p className={styles.p}>
          Platform Sahibi; taraflar arasındaki uyuşmazlıklardan, taşıma sırasında meydana gelen
          zararlardan, ödeme, teslimat, gecikme veya kayıplardan hiçbir şekilde sorumlu tutulamaz.
        </p>
      </Section>

      {/* 9 */}
      <Section title="9. Sözleşmenin Yürürlüğü">
        <p className={styles.p}>
          İşbu Sözleşme, Kullanıcı’nın KolayYük uygulamasına kayıt olması veya uygulamayı kullanmasıyla
          birlikte yürürlüğe girer.
        </p>
      </Section>

      {/* 10 */}
      <Section title="10. Uyuşmazlıkların Çözümü">
        <p className={styles.p}>
          İşbu Sözleşme Türk Hukuku’na tabidir. Taraflar arasında doğabilecek uyuşmazlıklarda Türkiye
          Cumhuriyeti mahkemeleri ve icra daireleri yetkilidir.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl font-extrabold text-black">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

const styles = {
  p: "text-gray-700 leading-relaxed mt-3",
  ul: "mt-3 ml-5 list-disc text-gray-700 leading-relaxed",
  li: "mt-2",
};
